<template>
  <div class="container">
    <div class="services">
      <transition-group appear name="slide-fade">
        <div :key="0" class="buttons-container">
          <div v-for="(slice, index) in slices" :key="index" v-on:click="filter(index)" class="button" :class="{ 'active': activeButton == index }">{{ $prismic.richTextAsPlain(slice.primary.services_headline) }}</div>
        </div>
        <div v-for="(slice, index) in slices" :key="index + 1" class="grid-container columns is-multiline" :class="{ 'hidden': activeButton != index }">
          <template v-if="slice.primary.services_type == 'Grid'">
            <div class="column is-half-desktop is-12-tablet services-description">
              <h1 class="title title-white">{{ $prismic.richTextAsPlain(slice.primary.services_headline) }}</h1>
              <br/>
              <p>{{ $prismic.richTextAsPlain(slice.primary.services_content) }}</p>
            </div>
            <div class="column is-half-desktop is-12-tablet gallery-container">
              <div class="columns is-multiline is-mobile">
                <div v-for="(item, index) in slice.items" :key="index" class="column is-4">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-square">
                        <prismic-image :field="item.service_icon"/>
                      </figure>
                      <prismic-rich-text class="card-label subtitle" :field="item.service_label" :htmlSerializer="labelHtmlSerializer" />
                      <div v-if="item.service_content.length" class="card-content is-overlay is-clipped">
                        <div class="card-details">
                          <div class="has-text-white">{{ $prismic.richTextAsPlain(item.service_content) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="how-columns" v-else>
            <div class="columns is-12 is-variable">
              <div class="column is-one-third" v-for="(item, index) in slice.items" :key="index">
                <div class="card">
                  <div class="card-image">
                    <div class="card-label subtitle">{{ $prismic.richTextAsPlain(item.service_label) }}</div>
                    <prismic-image :field="item.service_icon" width="150" height="150" />
                    <div class="card-content">
                      <div class="card-details">
                        <div>{{ $prismic.richTextAsPlain(item.service_content) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import prismicDOM from 'prismic-dom';
const Elements = prismicDOM.RichText.Elements;

const labelHtmlSerializer = function (type, element, content, children) {
  if (content) {
    if (content.includes("/")) {
      return content.replace("/", "/<wbr>");
    }
  }

  return null;
}

export default {
  name: 'Services',
  data () {
    return {
      labelHtmlSerializer,
      servicesButtons: [],
      slices: [],
      activeButton: 0,
    }
  },
  methods: {
    getServices (uid) {
      this.$prismic.client.getSingle('services')
        .then((document) => {
          if (document) {
            this.slices = document.data.body
          }
        })
    },
    filter (idx) {
      document.querySelectorAll('.grid-container').forEach(function(service, index) {
        if (index == idx) {
          service.classList.remove('hidden');
        } else {
          service.classList.add('hidden');
        }
      });

      document.querySelectorAll('.button').forEach(function(button, index) {
        if (index == idx) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }
  },
  created () {
    this.getServices();
    this.activeButton = 0;
  },
  filters: {
    insertWordBreak: function(str) {
      return str.replace("/","/<wbr>");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";

.buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
  .button {
    background: transparent;
    border: transparent;
    transition: 0.3s all ease;
    text-transform: uppercase;
    margin: 0 5px;
    cursor: pointer;
    &:hover {
      background: #dddddd;
    }
    &.active {
      background: $navy;
      color: white;
    }
  }
}

.services-description {
  background: $navy;
  color: $white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 3rem;
  @media screen and (max-width: $desktop) {
    padding: 3rem;
    margin: 1.5rem 0;
  }
  @media screen and (max-width: $tablet) {
    margin: 0;
  }
}

.grid-container {
  &.hidden {
    display: none;
  }
}

.gallery-container {
  padding: 0;
  padding-left: 1.5rem;
  flex-wrap: wrap;
  @media screen and (max-width: $desktop) {
    padding-left: 0;
  }
  .columns {
    @media screen and (max-width: $tablet) {
      margin: 0;
    }
  }
  .column {
    @media screen and (max-width: $tablet) {
      padding: 0;
    }
    .card {
      border: none;
      .card-image {
        background: $lightBlue;
        .image {
          width: 100%;
          overflow: hidden;
          position: relative;
          max-width: 125px;
          margin: auto;
          @media screen and (max-width: $widescreen) {
            max-width: 80px;
          }
          img {
            width: 100% !important;
            height: auto !important;
            margin: auto !important;
            position: absolute !important;
            top: calc(-100% - 30px) !important;
            right: -100% !important;
            bottom: -100% !important;
            left: -100% !important;
          }
        }
        .card-label {
          // padding-bottom: 10px;
          text-align: center;
          margin-bottom: 0;
          bottom: 10px;
          position: absolute;
          left: 0;
          right: 0;
          word-wrap : break-word;
        }
      }
      .card-content {
        background: rgba(0, 0, 0, 0.8);
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        opacity: 0;
        -webkit-transition: all 0.2s ease-in-out 0s;
        -moz-transition: all 0.2s ease-in-out 0s;
        transition: all 0.2s ease-in-out 0s;
        .card-details {
          position: absolute;
          text-align: center;
          font-size: 12px;
          padding-left: 1em;
          padding-right: 1em;
          width: 100%;
          top: 50%;
          left: 50%;
          opacity: 0;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          -webkit-transition: all 0.2s ease-in-out 0s;
          -moz-transition: all 0.2s ease-in-out 0s;
          transition: all 0.2s ease-in-out 0s;
        }
      }
      &:hover {
        .card-content {
          opacity: 1;
          .card-details {
            top: 50%;
            left: 50%;
            opacity: 1;
            h3 {
              color: $white;
              font-weight: 500;
              letter-spacing: 0.15em;
              margin-bottom: 0.5em;
              text-transform: uppercase;
            }
            p {
              color: $white;
              font-size: 0.8em;
            }
          }
        }
      }
    }
  }
}

.how-columns {
  width: 100%;
  margin-bottom: calc(1.5rem - 0.75rem);
  .columns {
    background: $navy;
    padding: 3rem 0;
    margin: 0;
    .column {
      display: flex;
      .card {
        border: none;
        background: $white;
        max-width: 300px;
        margin: 0 auto;
        .card-image {
          text-align: center;
        }
        .card-label {
          margin-top: 1.5rem;
        }
        .card-content {
          text-align: left;
        }
      }
    }
  }
}

.fadeIn-bottom {
  top: 80%;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
